<template>
  <span>    
    <span v-if="inMessage">
        <b-dropdown-item
              v-if="action =='add'" @click="openAssign" :size="size" :title="$t('ASSIGN')" class="no-border"
            >{{ $t("ASSIGN") }}</b-dropdown-item>
<b-dropdown-item
              v-if="action =='clear'" @click="clearBtn" :size="size" :title="$t('UNASSIGN')" class="no-border"
            >{{ $t("UNASSIGN") }}</b-dropdown-item>
    </span>
    <span v-if="!inMessage">
      <b-button v-if="action =='add'" @click="openAssign" variant="primary" :size="size" :title="$t('ASSIGN')" class="float-right">{{ $t("ASSIGN") }}</b-button>
      <b-button v-if="action =='clear'" @click="clearBtn" variant="secondary" :size="size" :title="$t('UNASSIGN')" class="float-right">{{ $t("UNASSIGN") }}</b-button>
    </span>

     <b-modal id="functionbox-assign-user" size="lg"
      v-model="show"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      visible
      ok-only
      :dialog-class="teams.theme"
      @ok="cancelBtn"
      centered
      :ok-title="$t('CANCEL')"
     >

<b-form inline class="mt-2">
          <b-form-input trim
            v-model="searchText"
            :placeholder="$t('SEARCH')"
            @keydown.enter.prevent
            class="searchText newline-mobile ml-0"
          ></b-form-input>
        </b-form>

        <b-table
          small
          class="mt-2"
          :busy="loading"
          bordered
          :items="items"
          hover
          :fields="fields"
          @row-clicked="clickedRow"
        >

          <template v-slot:cell(name)="data">
            <b-form inline>
              <b-img
                class="profileImage"
                src="/img/default-avatar.png"
                alt="placeholder"
                rounded="circle"
              ></b-img>
              {{ data.item.name }}
            </b-form>
          </template>

          <template v-slot:cell(email)="data">{{ data.item.email }}</template>

          <template v-slot:cell(id)="data">
            <b-form inline>
              <UserInfo
                image="/img/default-avatar.png"
                :primary="data.item.name"
                :secondary="data.item.email"
              ></UserInfo>
            </b-form>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
        </b-table>

        <b-pagination
          class="mt-2"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="limit"
          align="center"
          pills
          @input="getCurrentUsers"
        >
        </b-pagination>

  </b-modal>

        

</span>
</template>
<script>
import UserInfo from "../Layout/UserInfo";
export default {
  components: { UserInfo },
  props: {
    inMessage: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    selected: {
      default: () => [],
      type: Array,
    },
    functionbox_uuid: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "add",
    },
    size: {
      type: String,
      default: "md",
    }
  },
  data() {
    return {
      show: false,
      user_uuid: "",
      loading: false,
      searchText: "",
      limit: 45,
      currentPage: 1,
      totalItems: 0,
      items: [],
      fields: [
        {
          key: "id",
          class: "hidden-not-mobile",
          thClass: "",
        },
        {
          key: "name",
          label: this.$t("NAME"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "email",
          label: this.$t("EMAIL"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "title",
          label: this.$t("TITLE"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        },
        {
          key: "department",
          label: this.$t("DEPARTMENT"),
          class: "text-break clickable hidden-mobile",
          sortable: false,
        }
      ]
    };
  },
  methods: {
    openAssign(){
      this.user_uuid = "";
      this.show = true;
    },
    cancelBtn()
    {
      this.user_uuid = "";
      this.show = false;
    },
    clearBtn() {
      let self = this;  
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          dialogClass: this.teams.theme,
          cancelTitle: this.$t("NO"),
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.$http
              .post(self.user.hostname + "/message/assign", {
                functionbox_uuid: self.functionbox_uuid,
                messageUuids: self.selected,
                user_uuid: "",
                clear: true
              })
              .then(function () {
                self.$noty.info(self.$t("UPDATED"));
                self.$emit('assigned');
                self.cancelBtn();
              })
              .catch(() => {
              });
          }
        })
        .catch(function () {});
    },
    clickedRow(item) {
      let self = this;  
      let selectedUuid = item.user_uuid;
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
          dialogClass: this.teams.theme,
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.$http
              .post(self.user.hostname + "/message/assign", {
                functionbox_uuid: self.functionbox_uuid,
                messageUuids: self.selected,
                user_uuid: selectedUuid,
                clear: false
              })
              .then(function () {
                self.$noty.info(self.$t("UPDATED"));
                self.$emit('assigned');
                self.cancelBtn();
              })
              .catch(() => {
              });
          }
        })
        .catch(function () {});
    },
    getCurrentUsers: function () {
      this.loading = true;
      let self = this;
      this.$http
        .post(this.user.hostname + "/administration/functionbox/users", {
          page: this.currentPage,
          functionbox_uuid: this.functionbox_uuid,
          state: 1,
          limit: parseInt(this.limit),
          search_text: this.searchText,
        })
        .then((response) => {
          self.loading = false;
          self.items = response.data.items;
          self.totalItems = response.data.count;
        })
        .catch(() => {
          self.loading = false;
        });
    }
  },
  computed: {
    saveDisabled(){
      return this.user_uuid == "";
    }
  },
  watch: {
    searchText: function () {
      if (this.searchText.length == 0) {
        this.getCurrentUsers();
      }
      if (this.searchText.length >= 2) {
        this.getCurrentUsers();
      }
    },
    limit: function () {
      this.getCurrentUsers();
    },
  },
  mounted() {
    this.getCurrentUsers();
  },
};
</script>
<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
